import { OrderItem } from "hooks/useFulfillmentBatch";
import { LoaderFunctionArgs } from "react-router-dom";
import { fetcher } from "services/api.service";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: LoaderFunctionArgs) => {
  const { batchId, itemId } = params;
  const item = await fetcher<OrderItem>(`/fulfillment_batches/${batchId}/items/${itemId}`);

  return { item };
});
